/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { typeDiffusionPackSchema } from "./typeDiffusionPackSchema.ts";
import { z } from "zod";

export const partenaireSchema = z.object({
      "partenaire": z.string().describe("Code du partenaire").optional(),
  "label": z.string().describe("Nom du partenaire").optional(),
  "code": z.string().describe("Code").optional(),
  "nombreAnnonces": z.number().int().describe("Nombre d'annonces diffusées via ce partenaire").optional(),
  "quotaAnnonces": z.number().int().describe("Quota d'annonces du pack souscrit par l'office (absent si illimité ou non souscrit)").optional(),
  "typeDiffusion": z.lazy(() => typeDiffusionPackSchema).describe("Type de diffusion du pack souscrit (rabattu depuis le vocabulaire de la base — limite max/min, consommation → LIMITED ; illimite → UNLIMITED)").optional()
      })